// extracted by mini-css-extract-plugin
module.exports = {"Active":"NavigationItem_Active__UbI8w","NavigationItem":"NavigationItem_NavigationItem__2SpXc"};